import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { CommonOptions, DashBoardFiltersBase } from 'src/app/core/interfaces/interfaces';
import { CommonService } from 'src/app/core/services/modules/common.service';
import { DashBoardService, ProjectDailyByEmployerResponse, ProjectDailySummaryItem } from 'src/app/core/services/modules/dashboard.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { JsonDashboardFiltersService } from 'src/app/core/services/json-service/json-dashboardFilters.service';
import { User } from 'src/app/core/models/User';
import { AuthService } from 'src/app/core/services/modules/auth.service';
import { Company } from 'src/app/core/models/Company';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {ActivatedRoute} from '@angular/router';

export interface Total {
  Accomplish: number;
  Active: number;
  Expiry: number;
  Inactive: number;
  NewPersonal: number;
  NoCumple: number;
  Presence: number;
  Total: number;
  TotalLast: number;
  CheckedInOnly: number;
}

export interface ChartData {
  labels: string[];
  datasets: any[];
}

export interface ChartCategory {
  key: string;
  label: string;
  color: string;
}

@Component({
  selector: 'app-custom-page',
  templateUrl: './custom-page.component.html',
  styleUrls: ['./custom-page.component.scss']
})

export class CustomPageComponent implements OnInit {
  userAuth: User;
  selectedAmin: Company;
  formFilters: FormGroup;
  showAllList = false;
  categorySelet = true;
  chartDisplayLimit = 10;
  showAllCompanies = false;
  flagChangeFilter = false;
  showOnlyWithAttendance = false;
  selectedChartCategory = 'Present';
  production: boolean = environment.production;
  projectSummaryData: ProjectDailyByEmployerResponse | null = null;

  data: any[] = [];
  person: any[] = [];
  proyects: any[] = [];
  companies: any[] = [];
  employers: any[] = [];
  contracts: any[] = [];
  dataFilter: any[] = [];
  permissions: string[] = [];
  rawChartData: ProjectDailySummaryItem[] = [];
  jsonDashboardFilters: DashBoardFiltersBase[];
  dashboardPersonalFilter: CommonOptions[] = [];

  today: Date = new Date();
  controlPerson = new FormControl();
  controlFilter = new FormControl();
  controlProyects = new FormControl();
  controlCompanies = new FormControl();
  controlEmployers = new FormControl();
  controlContracts = new FormControl();

  @ViewChild('scrollSummaryNames') scrollSummaryNames: ElementRef;
  @ViewChild('scrollSummaryContent') scrollSummaryContent: ElementRef;

  // Data properties
  total: Total = {
    Accomplish: 0,
    Active: 0,
    Expiry: 0,
    Inactive: 0,
    NewPersonal: 0,
    NoCumple: 0,
    Presence: 0,
    Total: 0,
    TotalLast: 0,
    CheckedInOnly: 0
  };

  // Chart properties
  public employerChart?: Chart;

  // Chart categories
  chartCategories: ChartCategory[] = [
    {key: 'Present', label: 'Asistentes', color: '#66BB6A'},
    {key: 'Active', label: 'Activos', color: '#2196F3'},
    {key: 'CheckedInOnly', label: 'Sin Salida', color: '#FF9800'},
    {key: 'NewPersonal', label: 'Nuevo Personal', color: '#9C27B0'},
    {key: 'Compliant', label: 'Cumple', color: '#4CAF50'},
    {key: 'NonCompliant', label: 'No Cumple', color: '#F44336'}
  ];

  token = '';

  constructor(private dashboardService: DashBoardService,
              private commonService: CommonService,
              private jsonDashboardFiltersService: JsonDashboardFiltersService,
              private fb: FormBuilder,
              private cdr: ChangeDetectorRef,
              private ar: ActivatedRoute
  ) {
    this.formFilters = this.fb.group({
      selectedDate: [new Date()],
      estado: 'Active',
      variaciones: '-1',
      asistencia: '-1',
      cumplimiento: '-1',
      categorias: '-1',
      sexo: '-1',
      rango: '-1'
    });
    this.jsonDashboardFilters = this.jsonDashboardFiltersService.dashBoardFilters;
    this.ar.params.subscribe((rest:any) => {
      this.token = rest!.token;
      this.commonService.getUserInfoWithToken(this.token).subscribe(userinfo => {
        this.permissions = userinfo.claims;
      });
      this.commonService.getCommonOptions('DashboardPersonalFilter', this.token).subscribe((data: CommonOptions[]) => {
        this.dashboardPersonalFilter = data;
        this.controlFilter.setValue('byPersona');
      });
      this.getContractValidateExist();
    });
  }

  ngOnInit(): void {
    Chart.register(...registerables, ChartDataLabels);
    this.person.push({Name: 'Todas las personas', Id: '-1'});
    this.controlPerson.setValue('-1');
    this.categorySelet = true;
    this.showOnlyWithAttendance = true;
    this.refreshEmployerChart();

    setTimeout(() => {
      this.loadData();
    }, 100);
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroyEmployerChart();
  }

  loadData(): void {
    const projectId = this.controlProyects.value;

    if (!projectId || projectId === '-1') {
      return;
    }
    this.loadSummaryData();
    this.loadChartData();
  }

  loadSummaryData(): void {
    const projectId = this.controlProyects.value;
    const selectedDate = this.formatDateBackend(this.formFilters.get('selectedDate')?.value);
    const category = this.formFilters.get('categorias').value;
    const sex = this.formFilters.get('sexo').value;
    const employerIds = this.getSelectedEmployerIds();
    const contractIds = this.controlContracts.value !== '-1' ? [this.controlContracts.value] : [];

    if (!projectId || projectId === '-1') {
      return;
    }
    this.dashboardService.getProjectDailySummary(
      this.token,
      projectId,
      selectedDate,
      category,
      sex,
      employerIds,
      contractIds
    ).subscribe(
      (data: any) => {
        if (data && typeof data === 'object' && !Array.isArray(data) && data.Assigned !== undefined) {
          this.projectSummaryData = data as ProjectDailyByEmployerResponse;
          this.updateTotalFromSummaryData(this.projectSummaryData);
        } else {
        }
      },
      (error) => {
      }
    );
  }

  loadChartData(): void {
    const projectId = this.controlProyects.value;
    const selectedDate = this.formatDateBackend(this.formFilters.get('selectedDate')?.value);
    const category = this.formFilters.get('categorias').value;
    const sex = this.formFilters.get('sexo').value;
    const employerIds = this.getSelectedEmployerIds();
    const contractIds = this.controlContracts.value !== '-1' ? [this.controlContracts.value] : [];

    if (!projectId || projectId === '-1') {
      return;
    }
    this.dashboardService.getProjectDailyByEmployer(
      this.token,
      projectId,
      selectedDate,
      category,
      sex,
      employerIds,
      contractIds
    ).subscribe(
      (data: any) => {
        if (Array.isArray(data)) {
          this.rawChartData = data;
        } else {
          this.rawChartData = [];
        }
        setTimeout(() => {
          this.refreshEmployerChart();
        }, 100);
      },
      (error) => {
        this.rawChartData = [];
      }
    );
  }

  getSelectedEmployerIds(): string[] {
    const employerId = this.controlEmployers.value;
    if (!employerId || employerId === '-1') {
      return [];
    }
    return [employerId];
  }

  updateTotalFromSummaryData(data: ProjectDailyByEmployerResponse): void {
    this.total = {
      ...this.total,
      Active: data.Active,
      Total: data.Assigned,
      NewPersonal: data.NewPersonal,
      Presence: data.Present,
      Accomplish: data.Compliant,
      NoCumple: data.NonCompliant,
      CheckedInOnly: data.CheckedInOnly
    };
  }

  onChartCategoryChange(category: string): void {
    this.selectedChartCategory = category;
    this.refreshEmployerChart();
  }

  private refreshEmployerChart(): void {
    if (this.employerChart) {
      this.employerChart.destroy();
      this.employerChart = undefined;
    }
    this.destroyEmployerChart();
    this.createEmployerChart();
  }

  private createEmployerChart(): void {
    const canvas = document.getElementById('employerChart');
    if (!(canvas instanceof HTMLCanvasElement)) {
      return;
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }

    const chartData = this.getEmployerChartData();
    const cat = this.chartCategories.find(c => c.key === this.selectedChartCategory);
    if (!cat) {
      return;
    }
    const label = cat.label;

    if (this.employerChart) {
      this.employerChart.destroy();
    }

    this.employerChart = new Chart(ctx, {
      type: 'bar',
      data: chartData,
      options: this.getBarChartOptions(
        `Distribución de ${label.toLowerCase()}`,
        'Empresas',
        label
      ),
      plugins: [ChartDataLabels]
    });
  }

  private getEmployerChartData(): ChartData {
    const key = this.selectedChartCategory;
    const selCat = this.chartCategories.find(c => c.key === key);
    if (!selCat) {
      return { labels: [], datasets: [] };
    }
    const label     = selCat.label;
    const bgColor   = selCat.color;
    const bdColor   = this.darkenColor(bgColor);

    let items = this.rawChartData
      .filter(i => !!i.EmployerName && i.EmployerName !== 'No Employer')
      .map(i => ({
        name:  i.EmployerName as string,
        value: ((i as any)[key] as number) || 0
      }))
      .sort((a, b) => b.value - a.value);

    if (!this.showAllList && (this.showOnlyWithAttendance || !this.showAllCompanies)) {
      items = items.filter(i => i.value > 0);
    }

    if (!this.showAllList && !this.showAllCompanies && !this.showOnlyWithAttendance) {
      items = items.slice(0, this.chartDisplayLimit);
    }

    if (items.length === 0) {
      items = this.employers
        .filter(e => !!e.Name && e.Name !== 'No Employer')
        .map(e => ({ name: e.Name, value: 0 }))
        .sort((a, b) => a.name.localeCompare(b.name));

      if (!this.showAllList && !this.showAllCompanies && !this.showOnlyWithAttendance) {
        items = items.slice(0, this.chartDisplayLimit);
      }
    }

    return {
      labels: items.map(i => i.name),
      datasets: [{
        label:           `${label} por empresa`,
        data:            items.map(i => i.value),
        backgroundColor: bgColor,
        borderColor:     bdColor,
        borderWidth:     1,
        borderRadius:    4,
        borderSkipped:   false,
      }]
    };
  }

  private darkenColor(color: string): string {
    const colorMap: { [key: string]: string } = {
      '#66BB6A': '#43A047',
      '#2196F3': '#1976D2',
      '#FF9800': '#F57C00',
      '#9C27B0': '#7B1FA2',
      '#4CAF50': '#388E3C',
      '#F44336': '#D32F2F'
    };
    return colorMap[color] ? colorMap[color] : color;
  }

  private getBarChartOptions(title: string, xAxisTitle: string, yAxisTitle: string): any {
    return {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        intersect: false,
        mode: 'index'
      },
      plugins: {
        title: {
          display: true,
          text: title,
          font: {
            size: 16,
            weight: 'bold'
          },
          padding: 20
        },
        legend: {
          display: false
        },
        tooltip: {
          backgroundColor: 'rgba(0,0,0,0.8)',
          titleColor: 'white',
          bodyColor: 'white',
          borderColor: '#ddd',
          borderWidth: 1,
          callbacks: {
            label: (context: any) => {
              const value = Number(context.parsed.y);
              const total = context.dataset.data.reduce((a: number, b: number) => a + b, 0);
              const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
              return `${context.label}: ${value} (${percentage}%)`;
            }
          }
        },
        datalabels: {
          anchor: 'end',
          align: 'end',
          offset: 8,
          color: '#000',
          font: {
            weight: 'bold',
            size: 14
          },
          formatter(value: any, context: any) {
            return value;
          }
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: yAxisTitle,
            font: {
              weight: 'bold'
            }
          },
          ticks: {
          }
        },
        x: {
          title: {
            display: true,
            text: xAxisTitle,
            font: {
              weight: 'bold'
            }
          },
          ticks: {
            maxRotation: 45,
            minRotation: 0
          }
        }
      },
      animation: {
        duration: 1000,
        easing: 'easeInOutQuart'
      }
    };
  }

  toggleShowAllCompanies(): void {
    // Al tocar “Limited/All” siempre quito los otros dos modos:
    this.showAllCompanies       = !this.showAllCompanies;
    this.showOnlyWithAttendance = false;
    this.showAllList            = false;
    this.refreshEmployerChart();
  }

  getTotalCompaniesCount(): number {
    if (!Array.isArray(this.rawChartData)) {
      return 0;
    }
    return this.rawChartData.filter(item => item.EmployerName && item.EmployerName !== 'No Employer').length;
  }

  getDataStatusColor(): string {
    return this.rawChartData && this.rawChartData.length > 0 ? '#28a745' : '#dc3545';
  }

  getChartHeight(): string {
    return this.showAllCompanies && this.getTotalCompaniesCount() > 15 ? '650px' : '450px';
  }

  hasChartData(): boolean {
    return Array.isArray(this.rawChartData) && this.rawChartData.length > 0;
  }

  hasNoChartData(): boolean {
    return !Array.isArray(this.rawChartData) || this.rawChartData.length === 0;
  }

  getChartDataLength(): number {
    return Array.isArray(this.rawChartData) ? this.rawChartData.length : 0;
  }

  private destroyEmployerChart(): void {
    if (this.employerChart) {
      this.employerChart.destroy();
      this.employerChart = undefined;
    }
  }

  exportChartData(): void {
    const selectedCategory = this.chartCategories.find(cat => cat.key === this.selectedChartCategory);
    const chartData = this.getEmployerChartData();
    const exportData = {
      date: this.formFilters.get('selectedDate').value,
      category: selectedCategory ? selectedCategory.label : 'Unknown',
      employers: chartData.labels.map((label, index) => ({
        name: label,
        value: chartData.datasets[0].data[index]
      })),
      totalRecords: this.rawChartData.length,
      summaryData: this.projectSummaryData
    };

    const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `employer-daily-${exportData.date}-${this.selectedChartCategory}.json`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  getContractValidateExist() {
    this.dashboardService.getContractValidateExist(this.token).subscribe(rest => {
      this.companies = rest;
      if (this.companies.length === 1) {
        this.controlCompanies.setValue(rest[0].Id);
        this.getProjectSelectCompanyInfoId(rest[0].Id);
        this.getEmployerSelectCompanyInfoId(rest[0].Id, '');
        this.getContractSelectCompanyInfoId(rest[0].Id, '', '');
      } else if (this.companies.length > 1) {
        this.companies.push({Name: 'Todas las administradoras', Id: '-1'});
        this.companies.reverse();
        this.controlCompanies.setValue('-1');
        this.getProjectSelectCompanyInfoId(rest[0].Id);
        this.getEmployerSelectCompanyInfoId(rest[0].Id, '');
        this.getContractSelectCompanyInfoId(rest[0].Id, '', '');
      }
    });
  }

  onChangeSelectedCompany(e: any) {
    this.getProjectSelectCompanyInfoId(e);
    this.getEmployerSelectCompanyInfoId(this.controlCompanies.value, '');
    this.getContractSelectCompanyInfoId(this.controlCompanies.value,
      this.controlEmployers.value !== null && this.controlEmployers.value !== '-1' ? this.controlEmployers.value : '', e);
    this.clearformFilters();
    this.loadData();
  }

  onChangeSelectedPro(e: any) {
    this.getEmployerSelectCompanyInfoId(this.controlCompanies.value, e);
    this.getContractSelectCompanyInfoId(this.controlCompanies.value,
      this.controlEmployers.value !== null && this.controlEmployers.value !== '-1' ? this.controlEmployers.value : '', e);
    this.categorySelet = true;
    this.clearformFilters();
    this.loadData();
  }

  onChangeSelectedEmp(e: any) {
    this.getContractSelectCompanyInfoId(this.controlCompanies.value,
      this.controlEmployers.value !== null && this.controlEmployers.value !== '-1' ? this.controlEmployers.value : '',
      this.controlProyects.value);
    this.categorySelet = true;
    this.clearformFilters();
    this.loadData();
  }

  onChangeSelectedContract(e: any) {
    this.categorySelet = false;
    this.clearformFilters();
    this.loadData();
  }

  changeSubFilter(e: any) {
    this.dataFilter = [];
    this.flagChangeFilter = true;
    if (e === '-1') {
      this.dataFilter = [];
      this.flagChangeFilter = false;
    } else if (e === 'Active') {
      this.dataFilter = this.data.filter(x => x.Active > 0);
    } else if (e === 'Inactive') {
      this.dataFilter = this.data.filter(x => x.Inactive > 0);
    } else if (e === 'Expiry') {
      this.dataFilter = this.data.filter(x => x.Expiry > 0);
    }
    this.loadData();
  }

  changeSubSex(e: any) {
    this.loadData();
  }

  getProjectSelectCompanyInfoId(companyInfoId: any) {
    this.dashboardService.getProjectSelectCompanyInfoId(this.token, companyInfoId).subscribe(rest => {
      this.proyects = rest.filter((x: any) => x.IsActive === true);

      if (this.proyects.length === 1) {
        const firstProject = this.proyects[0];
        this.controlProyects.setValue(firstProject.Id);
        this.onChangeSelectedPro(firstProject.Id);
      } else if (this.proyects.length > 1) {
        this.proyects.sort((a, b) => a.Name.localeCompare(b.Name));
        const firstProject = this.proyects[0];
        this.controlProyects.setValue(firstProject.Id);
        this.onChangeSelectedPro(firstProject.Id);
      } else {
        this.controlProyects.setValue(null);
      }
    });
  }

  getEmployerSelectCompanyInfoId(companyInfoId: any, projectId: any) {
    this.dashboardService.getEmployerSelectCompanyInfoId(this.token, companyInfoId, projectId).subscribe(rest => {
      this.employers = rest !== null ? rest.filter((x: any) => x.IsActive === true) : [];
      this.employers.push({Name: 'Todas las empresas', Id: '-1', IsActive: true});
      this.controlEmployers.setValue('-1');
      this.employers.sort((a, b) => a.Name === 'Todas las empresas' ? -1 : (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0));
    });
  }

  getContractSelectCompanyInfoId(companyInfoId: any, employerId: any, projectId: any) {
    this.dashboardService.getContractSelectCompanyInfoId(this.token, companyInfoId, employerId, projectId).subscribe(rest => {
      this.contracts = rest.filter((x: any) => x.IsActive === true);
      this.contracts.push({ContractReview: 'Todos los contratos', ContractNumber: '', Id: '-1', IsActive: true});
      this.controlContracts.setValue('-1');
      this.contracts.sort((a, b) => a.ContractReview === 'Todos los contratos' ? -1 : (a.ContractReview >
        b.ContractReview) ? 1 : ((b.ContractReview > a.ContractReview) ? -1 : 0));
    });
  }

  clearformFilters() {
    this.formFilters.get('estado').setValue('-1');
    this.formFilters.get('variaciones').setValue('-1');
    this.formFilters.get('asistencia').setValue('-1');
    this.formFilters.get('cumplimiento').setValue('-1');
    this.formFilters.get('categorias').setValue('-1');
    this.formFilters.get('sexo').setValue('-1');
    this.formFilters.get('rango').setValue('-1');
    this.flagChangeFilter = false;
    this.dataFilter = [];
  }

  getPercentage(a: any, b: any, c?: any): string {
    let value = 0;
    if (a !== null && a !== undefined && b !== null && b !== undefined && (a !== 0 && b !== 0)){
      value = (a / b) * 100;
    }
    return value.toFixed() + '%';
  }

  // Fecha backend → 2025-07-16
  formatDateBackend(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

// Fecha visual → 16-07-2025 o 16-07-2025 10:45
  formatDateForView(): string {
    const date: Date = this.formFilters.get('selectedDate')?.value;
    if (!date) { return ''; }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const isToday = this.isSameDate(date, this.today);

    if (isToday) {
      const hoursRaw = new Date().getHours();
      const minutes = new Date().getMinutes().toString().padStart(2, '0');
      const hours = (hoursRaw % 12 || 12).toString().padStart(2, '0');
      const ampm = hoursRaw >= 12 ? 'PM' : 'AM';
      return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    }
    return `${day}-${month}-${year}`;
  }

  isSameDate(date1: Date, date2: Date): boolean {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  onDateChange(date: Date): void {
    if (!date || date > this.today) { return; }
    this.formFilters.get('selectedDate')?.setValue(date);
    this.loadData();
  }

  toggleOnlyWithPresence(): void {
    this.showOnlyWithAttendance = !this.showOnlyWithAttendance;
    this.showAllCompanies       = false;
    this.showAllList            = false;
    this.refreshEmployerChart();
  }

  toggleShowAllList(): void {
    this.showAllList = !this.showAllList;

    if (this.showAllList) {
      this.showAllCompanies       = false;
      this.showOnlyWithAttendance = false;
    } else {
      this.showAllCompanies       = true;
      this.showOnlyWithAttendance = false;
    }

    this.refreshEmployerChart();
  }

  exitPermission(permiso: string): boolean {
    let exit = false;
    const permisionsUserInfo  = this.permissions.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }
}
